import React              from 'react';
import InputAdornment     from '@mui/material/InputAdornment';
import IconButton         from '@mui/material/IconButton';
import KeyboardIcon       from '@mui/icons-material/Keyboard';
import TextField          from '@mui/material/TextField';
import VATHelperDialog    from '../membership/plans/edit/VATHelperDialog';
import { useTranslation } from 'react-i18next';
import { getCurrency }    from '@karpeleslab/klbfw';
import Grid               from '@mui/material/Grid';
import FormControlLabel   from '@mui/material/FormControlLabel';
import Checkbox           from '@mui/material/Checkbox';

const Price = (props) => {
	const { onValueChange, preferredCurrency, helperEnabled = true, vatIncluded, setVatIncluded, ...rest } = props;

	const [showVATHelper, setShowVATHelper] = React.useState(false);
	const handleOnChange = (e) => {
		onValueChange(e.target.value);
	};
	const { t } = useTranslation();
	const currency = preferredCurrency ?? getCurrency();
	return (
        <Grid container>
            <Grid item xs={12}>
				<TextField
					{...rest}
					onChange={handleOnChange}
					type='number'
					InputProps={
						{
							step: 'any',
							min: 0,
							startAdornment: <InputAdornment position='start'>{currency}</InputAdornment>,
							endAdornment: (helperEnabled && (!!setVatIncluded ? !vatIncluded : true)) ?
								(<InputAdornment position='end'>
									<IconButton
                                        disabled={rest.disabled}
                                        aria-label={t('vat_calculator_helper_lbl')}
                                        onClick={() => setShowVATHelper(true)}
                                        size="large">
										<KeyboardIcon/>

									</IconButton>
								</InputAdornment>) : undefined
						}
					}
				/>
			</Grid>
            {!!setVatIncluded && <Grid item xs={12}>
				<FormControlLabel
					control={
						<Checkbox
							checked={vatIncluded}
							onChange={e => setVatIncluded(e.target.checked)}
							color='primary'
						/>
					}
					label={t('vat_included_check')}
				/>
			</Grid>}
            <VATHelperDialog open={showVATHelper} setOpen={setShowVATHelper} onClose={onValueChange}/>
        </Grid>
    );
};

export default Price;
